import React from 'react'

export const Title = ({ title, icon, subtitle }: { title: string, icon: React.ReactNode, subtitle?: string }) => {
    return (
        <div className='d-flex justify-content-start align-items-center mb-3'>
            <div className='d-flex align-items-center gap-3'>
                {icon}
                <div className='d-flex flex-column'>
                    <div className='text-primary'>{title}</div>
                    {subtitle && <div className='text-xs text-secondary'>{subtitle}</div>}
                </div>
            </div>
        </div>

    )
}
